// extracted by mini-css-extract-plugin
export default {"container":"ManageMFA_container__+tWE6","optionContainer":"ManageMFA_optionContainer__GsHj7","details":"ManageMFA_details__yqaBV"};